import { render } from "./GCard.vue?vue&type=template&id=829ec2d2&ts=true"
import script from "./GCard.vue?vue&type=script&lang=ts"
export * from "./GCard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__